var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverPartnerMedallionLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SilverPartner-medallion",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.118,
    height: 157.964,
    viewBox: "0 0 111.118 157.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31929",
    "data-name": "Rectangle 31929",
    width: 111.118,
    height: 157.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40672",
    "data-name": "Path 40672",
    d: "M87.04,175.8a55.512,55.512,0,0,0,82.606-74.178,56.757,56.757,0,0,0-4.136-4.149L87.04,175.81Z",
    transform: "translate(-87.04 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40673",
    "data-name": "Path 40673",
    d: "M85.76,139.551c0,24.921,19.734,45.121,44.058,45.121s44.058-20.2,44.058-45.121S154.142,94.43,129.818,94.43s-44.058,20.2-44.058,45.121",
    transform: "translate(-85.76 -94.43)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M127.292,50.26,106.08,90.649h31.339L158.877,50.26H127.305Z",
    transform: "translate(-67.091 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14182",
    "data-name": "Group 14182",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 35.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M147.858,77.38H143.2a1.464,1.464,0,0,0-1.465,1.465h0v3.54a2.236,2.236,0,0,1-2.243,2.243H112.383a2.236,2.236,0,0,1-2.243-2.243h0v-3.54a1.464,1.464,0,0,0-1.465-1.465h-5.044a1.447,1.447,0,0,0-1.4,1.037L95.67,99.655h60.175l-6.561-21.238a1.475,1.475,0,0,0-1.4-1.037",
    transform: "translate(-70.179 -77.38)",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M131.569,86.44A55.561,55.561,0,0,0,90.3,179.2l78.47-78.47a55.3,55.3,0,0,0-37.2-14.288",
    transform: "translate(-76.01 -74.693)",
    fill: "#8a8a8a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(14.301 61.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14183",
    "data-name": "Group 14183",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 103.105,
    height: 103.04,
    fill: "#828080"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14184",
    "data-name": "Group 14184",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(10.36 57.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M129.2,94.43A45.122,45.122,0,1,1,84,139.551,45.121,45.121,0,0,1,129.2,94.43h0",
    transform: "translate(-84 -94.43)",
    fill: "#999898"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(12.642 57.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14185",
    "data-name": "Group 14185",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 88.13,
    height: 90.243,
    fill: "#8e8e8e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14186",
    "data-name": "Group 14186",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(15.002 0.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M144.06,90.631H112.721L87.58,50.32h31.831Z",
    transform: "translate(-87.58 -50.32)",
    fill: "#57a932"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40674",
    "data-name": "Path 40674",
    d: "M125.062,160.963l-13.549-23.481L97.95,114h54.224l-13.549,23.481-13.562,23.481Z",
    transform: "translate(-69.503 -31.355)",
    fill: "#bfbebf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40675",
    "data-name": "Path 40675",
    d: "M124.866,158.029,112.51,136.61l-12.37-21.42h49.465l-12.37,21.42-12.37,21.42Z",
    transform: "translate(-68.853 -31.002)",
    fill: "#d3d3d3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverPartnerMedallionLg);
export default __webpack_public_path__ + "static/media/SilverPartner-medallionLg.7f940f6641bf7f49a26a7b55bbd18214.svg";
export { ForwardRef as ReactComponent };